import React from 'react'
import { IconSVGType } from '../../../types/icons'

export const MasterCardWhiteIcon = (props: IconSVGType) => {
  return (
    <svg
      width='30'
      height='18'
      viewBox='0 0 30 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.275 14.575V14.275H28.4V14.225H28.1V14.275H28.225V14.575H28.275ZM28.85 14.575V14.225H28.75L28.65 14.475L28.55 14.225H28.45V14.575H28.525V14.3L28.625 14.525H28.7L28.8 14.3V14.575H28.85ZM13.775 16.325C13.85 16.375 13.925 16.45 14 16.5C12.575 17.45 10.85 18 9.025 18C4.025 18 0 13.975 0 9C0 4.025 4.025 0 9 0C10.85 0 12.55 0.55 13.975 1.5C13.9 1.55 13.825 1.625 13.75 1.675C11.625 3.525 10.425 6.175 10.425 9C10.425 11.8 11.65 14.475 13.775 16.325ZM20.125 0C18.275 0 16.575 0.55 15.15 1.5C15.225 1.55 15.3 1.625 15.375 1.675C17.5 3.525 18.7 6.175 18.7 9C18.7 11.8 17.475 14.475 15.375 16.325C15.3 16.375 15.225 16.45 15.15 16.5C16.575 17.45 18.3 18 20.125 18C25.1 18 29.125 13.975 29.125 9C29.125 4.025 25.1 0 20.125 0ZM14.55 1.925C14.425 2.025 14.325 2.1 14.2 2.2C12.325 3.85 11.125 6.3 11.125 9C11.125 11.7 12.325 14.15 14.225 15.8C14.325 15.9 14.45 16 14.575 16.075C14.7 15.975 14.8 15.9 14.925 15.8C16.8 14.15 18 11.7 18 9C18 6.3 16.8 3.85 14.9 2.2C14.8 2.125 14.675 2.025 14.55 1.925Z'
        fill='white'
      />
    </svg>
  )
}
